export default __webpack_public_path__ + "static/media/tick.bcbce540.svg";